
import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative pt-16 md:pt-20 pb-0 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/d1df2e73a9764db6639a242417e12cfb.jpg"
          alt="DMM FX口座開設 スマホで簡単手続き"
          title="DMM FX口座開設手順 画像付き解説"
          className="w-full h-full object-cover object-top"
          loading="lazy"
          decoding="async"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30"></div>
      </div>
      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24 lg:py-32">
        <div className="max-w-2xl">
          <span className="inline-block bg-teal-500/20 text-teal-300 text-xs md:text-sm font-semibold px-3 md:px-4 py-1 md:py-1.5 rounded-full mb-4 md:mb-6 border border-teal-400/30">
            最短即日・スマホで完結
          </span>
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 md:mb-6 leading-tight">
            DMM FX口座開設手順を<br />画像付きで解説
          </h1>
          <p className="text-sm md:text-lg text-white/80 mb-6 md:mb-8 leading-relaxed">
            初めてでも安心。たった4ステップ・約10分でFX口座が開設できます。<br className="hidden md:block" />
            実際の画面イメージとともに、わかりやすく手順を解説します。
          </p>
          <div className="flex flex-col sm:flex-row gap-3 md:gap-4 items-start sm:items-center">
            <a
              href="https://px.a8.net/svt/ejp?a8mat=4AX8OA+BW2OQA+1WP2+6JC82"
              rel="nofollow"
              className="bg-gradient-to-r from-teal-500 to-emerald-600 text-white px-6 md:px-8 py-3 md:py-4 rounded-lg text-base md:text-lg font-semibold hover:shadow-xl hover:scale-105 transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
            >
              <i className="ri-arrow-right-line"></i>
              今すぐ口座開設する
            </a>
            <img border={0} width="1" height="1" src="https://www13.a8.net/0.gif?a8mat=4AX8OA+BW2OQA+1WP2+6JC82" alt="" style={{ display: 'none' }} />
            <span className="text-white/60 text-xs md:text-sm">※口座開設・維持費は完全無料</span>
          </div>
        </div>
      </div>
    </section>
  );
}
